import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonButton, IonIcon, IonItem, IonLabel } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { copyOutline, hardwareChipOutline } from 'ionicons/icons';
import type { FormShortLinkListRow } from './form-short-link-list-row.model';

addIcons({ copyOutline, hardwareChipOutline });

@Component({
  selector: 'crowdctrl-form-short-link-nfc-row',
  standalone: true,
  imports: [CommonModule, IonItem, IonLabel, IonButton, IonIcon],
  templateUrl: './form-short-link-nfc-row.component.html',
  styleUrl: './form-short-link-nfc-row.component.css',
})
export class FormShortLinkNfcRowComponent {
  @Input({ required: true }) row!: FormShortLinkListRow;

  @Output() openUrl = new EventEmitter<FormShortLinkListRow>();
  @Output() copyUrl = new EventEmitter<{ row: FormShortLinkListRow; event: Event }>();

  get title(): string {
    return this.row.label?.trim() || `Tag ${this.row.id.slice(0, 8)}`;
  }

  onRowClick(): void {
    this.openUrl.emit(this.row);
  }

  onCopy(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.copyUrl.emit({ row: this.row, event });
  }
}
